import { useState } from "react"
import usePagination from "../../hooks/usePagination"
import CreateOrUpdateIllustrationMappingsFacility from "./components/CreateOrUpdateIllustrationMappingFacility"
import IllustrationMappingsTable from "./components/IllustrationTable"
import DeleteIllustrationMappingFacility from "./components/DeleteIllustrationMappingFacility"
import { useIllustrationMappingsData } from "../../hooks/useIllustrationMappings"
import ApiError from "../../components/ApiError"

const IllustrationMappings = () => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [filters, setFilters] = useState([])
  const [openAddModal, setOpenAddModal] = useState(false)
  const [editedIllustrationMappingId, setEditedIllustrationMappingId] =
    useState(null)
  const [deleteIllustrationMappingId, setDeleteIllustrationMappingId] =
    useState(null)

  const { data, isLoading, isError, error } = useIllustrationMappingsData({
    page,
    limit,
    filters,
  })

  const updateFilters = (data) => {
    // onPaginationChange({ ...pagination, pageIndex: 0 })
    setFilters(data)
  }

  const handleCloseDeleteModal = () => {
    setDeleteIllustrationMappingId(null)
  }

  const handleClose = () => {
    setEditedIllustrationMappingId(null)
    setOpenAddModal(false)
  }

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <>
      <div className="px-4 py-2 flex justify-between items-center mt-2">
        <h1 className="text-2xl font-bold">Manage Pathology Mappings</h1>
        <button
          className="bg-secondary hover:bg-secondary_dark text-white py-2 px-3 rounded flex items-center gap-2"
          onClick={() => setOpenAddModal(true)}
        >
          Add Pathology Mappings
        </button>
      </div>
      <IllustrationMappingsTable
        data={isLoading ? [] : data?.data}
        filters={filters}
        loading={isLoading}
        pageCount={isLoading ? 0 : data?.pages}
        pagination={pagination}
        setDeleteIllustrationMappingId={setDeleteIllustrationMappingId}
        setEditedIllustrationMappingId={setEditedIllustrationMappingId}
        setFilters={updateFilters}
        onPaginationChange={onPaginationChange}
      />
      {(openAddModal || editedIllustrationMappingId) && (
        <CreateOrUpdateIllustrationMappingsFacility
          filters={filters}
          illustrationMappingId={
            editedIllustrationMappingId ? editedIllustrationMappingId : null
          }
          limit={limit}
          page={page}
          onClose={handleClose}
        />
      )}
      {deleteIllustrationMappingId && (
        <DeleteIllustrationMappingFacility
          filters={filters}
          illustrationMappingId={deleteIllustrationMappingId}
          limit={limit}
          page={page}
          onClose={handleCloseDeleteModal}
        />
      )}
    </>
  )
}

export default IllustrationMappings
